module.exports = __webpack_public_path__ + "../static/pdf/handbook/de-DE_tele-look.pdf";